var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeenyiconsArrowLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:arrow-left-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69775 21.2833L15.7751 29.3581L13.9579 31.1727L2.78516 20L13.9579 8.82474L15.7751 10.6419L7.69775 18.7167H36.6831V21.2833H7.69775Z",
    fill: "#F3F3F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsArrowLeftSolid);
export default __webpack_public_path__ + "static/media/teenyicons_arrow-left-solid.6e20dd504505899413c294a607a187bb.svg";
export { ForwardRef as ReactComponent };